import { render, staticRenderFns } from "./WinbackPage.vue?vue&type=template&id=15abd631&scoped=true"
import script from "./WinbackPage.vue?vue&type=script&lang=js"
export * from "./WinbackPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15abd631",
  null
  
)

export default component.exports